import type { PaletteColor } from "@mui/material";
import type { NeutralColors } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";

const withAlphas = (color: PaletteColor): PaletteColor => {
  return {
    ...color,
    alpha4: alpha(color.main, 0.04),
    alpha8: alpha(color.main, 0.08),
    alpha12: alpha(color.main, 0.12),
    alpha30: alpha(color.main, 0.3),
    alpha50: alpha(color.main, 0.5),
  };
};

export const neutral: NeutralColors = {
  50: "#F8F9FA",
  100: "#F3F4F6",
  200: "#E5E7EB",
  300: "#D2D6DB",
  400: "#9DA4AE",
  500: "#6C737F",
  600: "#4D5761",
  700: "#2F3746",
  800: "#1C2536",
  900: "#111927",
};

// main: "#26393f",

// export const nlabteam = withAlphas({
//   lightest: "#FDA4A7",
//   light: "#EC6268",
//   main: "#E8751A",
//   dark: "#EA5C2B",
//   darkest: "#9B0208",
//   contrastText: "#FFFFFF",
// });

// export const success = withAlphas({
//   lightest: "#F0FDF9",
//   light: "#3FC79A",
//   main: "#2EB086",
//   dark: "#0B815A",
//   darkest: "#134E48",
//   contrastText: "#FFFFFF",
// });

// export const info = withAlphas({
//   lightest: "#ECFDFF",
//   light: "#CFF9FE",
//   main: "#06AED4",
//   dark: "#0E7090",
//   darkest: "#164C63",
//   contrastText: "#FFFFFF",
// });

// export const warning = withAlphas({
//   lightest: "#FFFAEB",
//   light: "#FEF0C7",
//   main: "#F79009",
//   dark: "#B54708",
//   darkest: "#7A2E0E",
//   contrastText: "#FFFFFF",
// });

// export const error = withAlphas({
//   lightest: "#FEF3F2",
//   light: "#FEE4E2",
//   main: "#FA7070",
//   dark: "#B42318",
//   darkest: "#7A271A",
//   contrastText: "#FFFFFF",
// });

export const nlabteam = withAlphas({
  lightest: "#D8E5EB", // светло-голубой
  light: "#A4BDC4", // серо-голубой
  main: "#26393F", // основной темно-синий/зеленовато-серый
  dark: "#1E2C31", // темно-синий/зеленовато-серый
  darkest: "#151B1E", // очень темный синий/зеленовато-серый
  contrastText: "#FFFFFF", // белый текст для контраста
});

export const success = withAlphas({
  lightest: "#DFFAE8", // светло-зеленый с белым
  light: "#A0D7B1", // мягкий зеленый
  main: "#5CB875", // насыщенный зеленый
  dark: "#448C5F", // темно-зеленый
  darkest: "#2B5E43", // очень темный зеленый
  contrastText: "#FFFFFF", // белый текст для контраста
});

export const info = withAlphas({
  lightest: "#E8F3FA", // светло-голубой
  light: "#B4D4E5", // голубой
  main: "#5BA9C7", // средний голубой
  dark: "#3F7B95", // темно-голубой
  darkest: "#264E60", // очень темный голубой
  contrastText: "#FFFFFF", // белый текст для контраста
});

export const warning = withAlphas({
  lightest: "#FFF9E8", // кремовый
  light: "#FFE3B3", // светло-оранжевый
  main: "#FFC165", // оранжевый
  dark: "#CC8F3D", // темно-оранжевый
  darkest: "#995E25", // очень темный оранжевый
  contrastText: "#FFFFFF", // белый текст для контраста
});

export const error = withAlphas({
  lightest: "#FDEAEA", // светло-розовый
  light: "#FAB4B4", // розовый
  main: "#E75C5C", // насыщенно-красный
  dark: "#B33A3A", // темно-красный
  darkest: "#7F2B2B", // очень темный красный
  contrastText: "#FFFFFF", // белый текст для контраста
});
